import { useRouter } from "next/router";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useFetchImpactShopStore } from "../../../store/impact-shop";
import { ImpactShopMessagesType } from "../constants";

const useImpactShopStore = useFetchImpactShopStore();

const impactShopNotificationType = {
  [ImpactShopMessagesType.Error]: "error",
  [ImpactShopMessagesType.Success]: "success",
};

type UseImpactShopMessage = {
  redirectTo?: string;
};

export const useImpactShopMessage = ({
  redirectTo = "",
}: UseImpactShopMessage) => {
  const router = useRouter();
  const { clearMessage, message } = useImpactShopStore();
  useEffect(() => {
    if (!message.body) return;

    const notificationType = impactShopNotificationType[message.type];
    // trigger toast
    toast[notificationType](message.body, {
      autoClose: 2000,
      onClose: clearMessage,
    });

    if (redirectTo) {
      if (message.type === ImpactShopMessagesType.Success) {
        // TODO: this is for demo purposes only
        setTimeout(() => {
          router.push(redirectTo);
        }, 2000);
        return;
      }
    }

    return clearMessage();
  }, [message]);
};
